<header>
  <i inlineSVG="/assets/icons/subs-icon-capsul.svg"></i>
  <span class="title">SUBTITLES</span>
  <div class="capsule-count">{{ formatSubtitlesCount() }}</div>
  <div class="close-btn" (click)="onClose()"><i class="fa fa-close"></i></div>
</header>
<div *ngFor="let subtitle of subtitles" class="subtitle">
  <span>{{ subtitle.language }}</span>
</div>
